// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"abe87180","153":"946802c8"}[chunkId] + ".chunk.js";
};